import React from 'react';
import HyperLink from 'components/Core/HyperLink';

import { AnchorMenuContainer } from './styles';

const AnchorMenu = ({ activeIndex, navigation, isMobile, isSticky }) => (
  <AnchorMenuContainer
    id="in-page-subnav"
    className={`${isMobile ? 'show' : isSticky ? 'show' : 'hide'}`}
  >
    <div className="in-page-subnav--navigation">
      {navigation?.navigation?.map((item, index) => {
        return (
          <HyperLink
            href={`#section-${item?.url?.split('#')[1]}`}
            id={`label-${item?.url?.split('#')[1]}`}
          >
            <p className={`${index === activeIndex ? 'active' : ''}`} title={item.label}>
              {item.label}
            </p>
          </HyperLink>
        );
      })}
    </div>
  </AnchorMenuContainer>
);

export default AnchorMenu;
